export default "__VITE_ASSET__a1c9695d__"